module.exports = __webpack_public_path__ + "img/CSV-icon.2b1c2cbf.jpeg";